import React, { useMemo, useState } from 'react'

// styles
import styles from './header.module.css'

// header sections
import HeaderLeftSection from './headerLeftSection'
import HeaderRightSection from './headerRightSection'

function HeaderComponent({ collapsed, setCollapsed }) {
    const initialState = {
        seconds: '00',
        minutes: '00',
        hours: '00',
        openProfile: false,
        openDrawer: false,
        filteredProjects: [],
        projectFormModal: false,
    }

    const [state, setState] = useState(initialState)

    useMemo(() => {
        if (typeof document !== 'undefined' && document.addEventListener) {
            document.addEventListener('visibilitychange', (e) => {
                e.preventDefault()
            })
        }
    }, [])

    // LOGOUT removed as it moved to sidebar

    return (
        <>
            <div className={styles.headerContainer}>
                <HeaderLeftSection
                    props={{
                        filteredProjects: state?.filteredProjects,
                        setState: (data) => setState(data),
                        state: state,
                        collapsed: collapsed,
                        setCollapsed: setCollapsed,
                    }}
                />
                <HeaderRightSection
                    props={{
                        state: state,
                        setState: (data) => setState(data),
                    }}
                />
            </div>
        </>
    )
}

export default React.memo(HeaderComponent)
